export var Options;
(function (Options) {
    function get(options) {
        return options;
    }
    Options.get = get;
})(Options || (Options = {}));
(function (Options) {
    Options.defaults = {};
})(Options || (Options = {}));
//# sourceMappingURL=options.js.map